import { type Project } from '../models';
import RecordFilter from './RecordFilter';

class TeamFilter extends RecordFilter {
  matches(record: { project: Project; team?: Project }) {
    return super.matches(record.project) || super.matches(record.team);
  }
}

export default TeamFilter;
